export default {
  payment: {
    success: {
      title: "Payment Successful",
      description: "Your payment has been processed successfully. Thank you for your purchase."
    },
    cancel: {
      title: "Payment Cancelled",
      description: "Your payment has been cancelled. You can try again anytime."
    },
    error: {
      title: "Payment Failed",
      description: "There was an error processing your payment. Please try again later."
    }
  },
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
  },
  nav: {
    home: 'Home',
    download: 'Download',
    profile: 'Profile',
    login: 'Login',
    logout: 'Logout',
    appName: 'Kalimba Flows'
  },
  home: {
    hero: {
      title: 'Kalimba Flows',
      subtitle: 'Follow Cursor • Build Tabs.',
      cta: 'Try Now'
    },
    features: {
      title: 'Features',
      subtitle: 'Everything you need to learn and play kalimba',
      smartPlay: {
        title: 'Follow the cursor',
        description: 'Follow the cursor and play in perfect rhythm with our responsive tracking system',
        features: [
          'Clear cursor guidance for accurate timing',
          'Adjustable playback speed for practice',
          'Flexible pause and resume while playing'
        ]
      },
      sharing: {
        title: 'Create Your Tabs',
        description: 'Design and edit your own kalimba tabs',
        features: [
          'Intuitive tab editor for kalimba',
          'Professional notation tools for all skill levels',
          'Save and organize your tabs'
        ]
      },
      library: {
        title: 'Official Tab Collection',
        description: 'Carefully curated kalimba tabs for learners of all levels',
        features: [
          'Classic pieces arranged in tab format',
          'Popular song tabs for easy start',
          'Progressive difficulty'
        ]
      }
    }
  },
  download: {
    hero: {
      title: 'Download Kalimba Flows',
      subtitle: ''
    },
    platforms: {
      appStore: 'Download on App Store',
      googlePlay: 'Download Android Apk',
      androidComingSoon: 'Coming Soon'
    },
    features: {
      instant: {
        title: 'Start Instantly',
        description: 'No installation needed, scan and play right away'
      },
      sync: {
        title: 'Cloud Sync',
        description: 'Progress saved in cloud, seamless across devices'
      },
      support: {
        title: 'Professional Support',
        description: 'Detailed tutorials and technical support for the best learning experience'
      }
    }
  },
  auth: {
    login: {
      title: 'Welcome Back',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      loginButton: 'Login',
      googleLogin: 'Continue with Google',
      forgotPassword: 'Forgot Password?',
      noAccount: 'No account?',
      register: 'Register now',
      rememberMe: 'Remember me'
    },
    register: {
      title: 'Create Account',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      confirmPasswordPlaceholder: 'Confirm Password',
      registerButton: 'Register',
      hasAccount: 'Already have an account?',
      login: 'Login now',
      passwordMismatch: 'Passwords do not match'
    },
    resetPassword: {
      title: 'Reset Password',
      emailPlaceholder: 'Enter your email',
      newPasswordPlaceholder: 'New Password',
      codePlaceholder: 'Verification Code',
      sendCode: 'Get Code',
      resetButton: 'Reset Password',
      backToLogin: 'Back to Login'
    },
    google: {
      processing: 'Processing Google login...',
      success: 'Google login successful',
      failed: 'Google login failed',
      retryLater: 'Google login failed. Please try again later',
      noAuthCode: 'No authorization code received',
      noToken: 'No token received in login response',
      redirecting: 'Login successful, redirecting...',
      returningToLogin: 'Returning to login page...'
    }
  },
  profile: {
    title: 'Profile',
    nickname: {
      label: 'Nickname',
      notSet: 'Not set',
      placeholder: 'Enter new nickname',
      maxLength: 'Maximum 20 characters'
    },
    account: {
      title: 'Account Settings',
      changePassword: 'Change Password'
    },
    danger: {
      title: 'Danger Zone',
      deleteAccount: 'Delete Account',
      deleteConfirm: {
        title: 'Delete Account',
        content: 'Are you sure you want to delete your account? This action cannot be undone. We will send a verification code to your email.',
      },
      codeSent: 'Verification code has been sent to your email',
      enterCode: 'Please enter the verification code',
      codePlaceholder: 'Enter verification code',
      sendCode: 'Send Code',
      deleteSuccess: 'Account deleted successfully'
    }
  }
};